import { inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DateRange, Week } from '@summit/models';
import { Dayjs } from 'dayjs';

export class SFormWizardHelper {
  router: Router;
  activeRoute: ActivatedRoute;

  constructor() {
    this.router = inject(Router);
    this.activeRoute = inject(ActivatedRoute);
  }
  public setDateRange(beginDateTime: Dayjs, endDateTime: Dayjs) {
    if (beginDateTime && endDateTime) {
      const newRange = new DateRange({
        begin: new Week(beginDateTime.startOf('day')).start,
        end: new Week(endDateTime.startOf('day').add(1, 'day')).end
      });
      //console.log(`new date: `, newRange);
      this.router.navigate(
        [],
        {
          relativeTo: this.activeRoute,
          queryParams: { WeekRange: JSON.stringify({ filterData: newRange }) },
          queryParamsHandling: 'merge',
          preserveFragment: true,
          skipLocationChange: false
        }
        // { relativeTo: this.route }
      );
    }
  }
  public setStep(stepId: string) {
    this.router.navigate(
      [],
      {
        relativeTo: this.activeRoute,
        queryParams: { step: stepId },
        queryParamsHandling: 'merge',
        preserveFragment: true,
        skipLocationChange: false
      }
      // { relativeTo: this.route }
    );
  }
}
